<div class="container" style="height: 900px;">
  <ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
    [spinner]="spinkit.skThreeBounce">
  </ng-http-loader>
  <!-- <div class="row row-class main_header">
    <div class="col-8">
      <span class="titles">Edit Profile </span>
    </div>
    <div *ngIf="UserCondition" class="col-4 back" (click)="logout()">
      <span class="icon icofont-logout"></span>
      Logout
    </div>
  </div> -->
  <div class="row row-class main_header">
    <div class="">
      <img src="../../../../assets/img/backMenu.svg" alt="" style="cursor: pointer;" (click)="goBackToProfile()">
    </div>
    <div>
      <h6 class="title_frd">My friends</h6>
      <div class="no-of-frd">{{noOfFriend}} available</div>
    </div>

  </div>

  <div *ngIf="listoffriends.length == 0">
    <div class="share_link" align="center" style="margin-top:60px">
      <h4>Share this link with your friends to compare</h4>
      <p class="text-center">{{Baselinkshare}} </p>
    </div>
    <div class="row share_link" align="center" style="margin-top: 35px;">
      <div class="col-4">
        <img src="./assets/img/facebook.png" (click)="onclickFb()" alt="">
      </div>
      <div class="col-4">
        <img src="./assets/img/whatsup.png" (click)="onclickwhatapp()" alt="">
      </div>
      <div class="col-4">
        <img src="./assets/img/Twitter.png" (click)="onclickTwitter()" alt="">
      </div>
    </div>
  </div>
  <div class="row" *ngIf="listoffriends.length != 0">
    <!-- <div class="col-6" *ngFor ="let friends of listoffriends" >
              <div class="card">
                    <tc-icon style="margin-left: 75%;margin-top: 7px;"  [iconClass]="'icofont-ui-delete'" (click) ="ondeletefriend(friends.friend_id)"  [tcColor]="'#47941b'"  [tcFontSize]="25" [padding]="0"></tc-icon>
                  <div  align ="center" class="image " *ngIf = "!friends.image">
                    <img src="./assets/img/PngItem_1503945.png"  alt="" width="80" >
                  </div>
                  <div class="avatar" *ngIf ="friends.image" align ="center">
                    <tc-avatar  [src]="friends.image" [size]="80"></tc-avatar>
                  </div>   
                <div class="friends py-1" align ="center" >
                    <h6 class="card-text">{{friends.tc_name}}</h6>  
                    <h6 class="card-text">{{friends.matchScore}}%</h6>
                </div>
                <br>
              </div>
            </div>   -->
    <div class="col-12" style="margin-top: 11%;">
      <div class="card" *ngFor="let friends of listoffriends">
        <div class="image pull-left">
          <span class="image " *ngIf="!friends.image">
            <img src="./assets/img/PngItem_1503945.png" alt="">
          </span>
          <span class="avatar" *ngIf="friends.image">
            <tc-avatar [src]="friends.image" [size]="76"></tc-avatar>
          </span>
        </div>
        <div class="content">
          <h6>{{friends.tc_name}}</h6>
          <span> {{friends.matchScore}}% </span>

        </div>
        <div class="clearfix">
          <tc-dropdown class="item" [close]="closeDropdown">
            <tc-dropdown-button>
              <div class="d-flex align-items-center">
                <mat-icon>more_vert</mat-icon>
              </div>
            </tc-dropdown-button>
            <tc-dropdown-content class="dropdown_wrap" [align]="'right'" [animation]="'fadeInUp'" [offset]="[10, 0]">
              <ul class="list">
                <li>
                  <a class="align-items-center dining">
                    <span class="icon icofont-dining-table" [tcFontSize]="28"></span>
                    Plan a meal with friend
                  </a>
                  <a class="align-items-center delete" (click)="ondeletefriend(friends.friend_id)">
                    <span class="icon icofont-ui-delete" [tcFontSize]="25"></span>
                    Delete
                  </a>
                </li>
              </ul>
            </tc-dropdown-content>
          </tc-dropdown>
        </div>
      </div>
    </div>

  </div>
  <!-- <div class="row" style="justify-content: center; margin-top: 20px; margin-bottom: 40px; ">
    <a [routerLink]="['../', 'profile']">
      <span class="moreTitle">
        Back to Profile
      </span>
    </a>
  </div> -->



  <!-- <div class="bottom_nav">
    <div class="row sticky stickyButton" style="padding-top: 5px;padding-bottom: 5px;">
      <div *ngIf="UserCondition" class="footernav h-100  py-2">
        <ul class="nav nav-pills row" style=" padding-left: 0px;padding-right: 0px;width: 100%;">
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../', 'food-menu']" class="nav-link">
              <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="24"></tc-icon>
              <span class="nav__text">Menu</span>
            </a>
          </li>
          <li class="nav-item col-xs-3 ">
            <a [routerLink]="['../',  'order-menu']" class="nav-link">
              <tc-icon [iconClass]="'icofont-shopping-cart'" [tcFontSize]="25"></tc-icon>
              <span class="nav__text">Cart</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../',  'order-list']" class="nav-link">
              <tc-icon [iconClass]="'icofont-food-basket'" [tcFontSize]="26"></tc-icon>
              <span class="nav__text">Orders</span>
            </a>
          </li>&nbsp;&nbsp;
          <li class="nav-item col-xs-3 py-1">
            <a [routerLink]="['../', 'edit-profile']" class="active nav-link">
              <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="22"></tc-icon>
              <span class="nav__text">Profile</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div> -->
</div>